import type { FeatureProduct } from '../../../options'
import { getFeatureProducts } from '../../../options/get-feature-products/get-feature-products'
import type { QuoteDocument, OptionsDocument } from 'paintscout'
import uniqBy from 'lodash/uniqBy'
import { getItemSection } from '../get-item-section'

export function getQuoteFeatureProducts({
  quote,
  options
}: {
  quote: QuoteDocument
  options: OptionsDocument
}): FeatureProduct[] {
  const featureProducts = getFeatureProducts({ options })
  const areaProducts = getAreaFeatureProducts({ quote, featureProducts })
  const lineItemProducts = getLineItemFeatureProducts({ quote, featureProducts })

  const res = uniqBy([...areaProducts, ...lineItemProducts], (product) => {
    return product.key
  })

  return res
}

const getAreaFeatureProducts = ({
  quote,
  featureProducts
}: {
  quote: QuoteDocument
  featureProducts: { [key: string]: FeatureProduct }
}): FeatureProduct[] => {
  const res: FeatureProduct[] = []
  Object.keys(quote?.areas ?? {}).forEach((areaKey) => {
    Object.keys(quote.areas[areaKey]?.substrates ?? {}).forEach((substrateKey) => {
      const substrateList = quote.areas[areaKey].substrates[substrateKey]
      substrateList.forEach((substrate) => {
        const substrateSection = getItemSection(substrate)
        if (substrateSection !== 'archived') {
          substrate?.products?.forEach((product) => {
            const featureProduct = featureProducts[product.product.name]
            if (featureProduct) {
              res.push(featureProduct)
            }
          })
        }
      })
    })
  })

  return res
}

const getLineItemFeatureProducts = ({
  quote,
  featureProducts
}: {
  quote: QuoteDocument
  featureProducts: { [key: string]: FeatureProduct }
}): FeatureProduct[] => {
  const res: FeatureProduct[] = []
  Object.keys(quote?.lineItems ?? {}).forEach((lineItemKey) => {
    const lineItem = quote.lineItems[lineItemKey]
    const lineItemSection = getItemSection(lineItem)
    if (lineItemSection !== 'archived') {
      lineItem?.materials?.forEach((material) => {
        const featureProduct = featureProducts[material.key]
        if (featureProduct) {
          res.push(featureProduct)
        }
      })
    }
  })

  return res
}
